import States from '../helpers/states';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import RafManager from '../helpers/raf-manager';
// import Scroll from '../helpers/scroll';
// import WebGLCanvas from '../webgl/webgl-canvas';
// import testFS from '../webgl/shaders/test.frag';
import CookiesManager from '../helpers/cookies-manager';

import Component from '../components/component';

export const PageEvent = {
	NEXT: '__pe_next',
	PAGE_DESTROYED: '__pe_page_destroyed'
};

export default class Page extends Component {
	constructor(page, components) {
		super();

		this.dom = {
			component: page,
			page,
			scrollable: this._find('.scrollable'),
			container: this._find('.container'),
			scrollSections: this._findAll('.scroll-section')
		};

		this.Components = components;

		bindAll(this, [
			'_update',
			'_scrollHandler',
			'_next',
			'_destroy'
		]);

		this._showTl = new TimelineMax({ paused: true });
		this._hideTl = new TimelineMax({
			paused: true,
			onStart: () => {
				this.dom.page.style.position = 'absolute';
				this.dom.page.style.top = -getWindowPosition() + 'px';

				// Reset scroll
				document.scrollingElement.scrollTop = document.scrollingElement.scrollLeft =
				document.body.scrollTop = document.body.scrollLeft =
				document.documentElement.scrollTop = document.documentElement.scrollLeft =
				window.scrollTop = window.scrollLeft = 0;
			},
			onComplete: this._destroy
		});
	}

	_retrieveDOM() {}

	_initTls() {
		this._showTl
			.from(this.dom.page, 0.5, { autoAlpha: 0 }, 0)

		this._hideTl
			.to(this.dom.page, 0.5, { autoAlpha: 0 }, 0)
			.add(() => {
				this._next();
			}, 0)
	}

	init() {
		super.init();
		
		this.dom.scrollUp = this.dom.container.querySelector('.ct--scroll-up');
		this.dom.header = this.dom.container.querySelector('.js-header');
		if (ENV.template == 'desktop') {
			this.dom.blockAnim = this.dom.page.querySelectorAll('.js-block-anim');
		}
		
		//Loader
		const loader = document.body.querySelector('.js-loader');
		if (loader != undefined && this.dom.page.dataset.entity == 'homepage') {
			if (CookiesManager.check('loaded') == true) {
				loader.parentNode.removeChild(loader);
				return;
			}

			loader.classList.add('show');
			this.isLoaded = false;

			setTimeout(()=>{
				if (this.isLoaded == false){
					loader.classList.add('animateOut');
					this.isLoaded = false;
					_callLoader();
				}
			}, 3800);
			window.addEventListener ? window.addEventListener("load", ()=>{(this.isLoaded == false) && this._callLoader()},false) : window.attachEvent && window.attachEvent("onload", ()=>{(this.isLoaded == false) && this._callLoader()});
		}
	}

	_callLoader() {
		CookiesManager.set('loaded', true, 7);
	}

	bind() {
		// RafManager.on(this._update);
		// if (this.scroll)
		//     this.scroll.on(this._scrollHandler);
		super.bind();

		if(this.dom.header) {

			//1er appel methode
			this._toggleScrollup();

			// Appel methode au scroll
			window.addEventListener('scroll', this._toggleScrollup.bind(this));

			// Anim au clique
			this.dom.scrollUp.addEventListener('click', () => {
				TweenMax.to(window, 1.2, { scrollTo: { y: 0, autoKill: false } , ease: Power3.easeInOut});
			});
		}

		// ANIM ALL JS BLOCK ANIM
		if( ENV.template == 'desktop' ) {
			this.controller = new ScrollMagic.Controller({globalSceneOptions: {reverse: true}});
			for (let i = 0; i < this.dom.blockAnim.length; i++) {
				let el = this.dom.blockAnim[i];
				let animation = el.getAttribute( 'data-animation' );

				switch( animation ) {
					case "timeline":
						var tween = new TimelineMax ()
							.add([
								TweenMax.fromTo(el, 1, {y: 150}, {y: 0, delay: (i * 0), ease: Power3.easeOut})
							]);

						// build scene
						new ScrollMagic.Scene({triggerElement: el, triggerHook: 'onEnter', offset: -150})
							.setTween(tween)
							// .addIndicators() // add indicators (requires plugin)
							.addTo(this.controller);

						// Get all dates
						let dates = el.querySelectorAll( '.dates .date' );
						for (let i = 0; i < dates.length; i++) {
							var tween = new TimelineMax ();
							var date = dates[i];
							var stroke = date.querySelector( '.js-anim-stroke' );
							var texts = date.querySelectorAll( '.js-anim-text' );
							var direction = ( date.classList.contains( 'offset' ) ) ? -1 : 1;
							tween.add([
								TweenMax.from( stroke, 0.6, { autoAlpha: 0, width: 0, ease: Power2.easeOut } ),
								TweenMax.staggerFrom( texts, 0.6, { autoAlpha: 0, x: direction * 35, delay: 0.25, ease: Power3.easeOut }, 0.1 )
							]);

							// build scene
							new ScrollMagic.Scene({triggerElement: date, triggerHook: 1, offset: 0, duration: "50%"})
								.setTween(tween)
								// .addIndicators() // add indicators (requires plugin)
								.addTo(this.controller);
						}

						break;
					default:
						var tween = new TimelineMax ()
							.add([
								TweenMax.fromTo(el, 1, {y: 150}, {y: 0, delay: (i * 0), ease: Power3.easeOut})
							]);

						// build scene
						new ScrollMagic.Scene({triggerElement: el, triggerHook: 'onEnter', offset: -150})
							.setTween(tween)
							// .addIndicators() // add indicators (requires plugin)
							.addTo(this.controller);
				}
			}
		}
	}

	_toggleScrollup(){

		//Calcul position fenetre
		var scrollMethod = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

		//Anim display scroll up
		if (scrollMethod > this.dom.header.getBoundingClientRect().height){
			TweenMax.to(this.dom.scrollUp, 0.6, {autoAlpha: 1, ease: Power3.easeInOut})
		}
		else if (scrollMethod < this.dom.header.getBoundingClientRect().height){
			TweenMax.to(this.dom.scrollUp, 0.4, {autoAlpha: 0, ease: Power3.easeInOut})
		}
	}

	unbind() {
		// RafManager.off(this._update);
		// if (this.scroll)
		//     this.scroll.off(this._scrollHandler);
	}

	show() {
		this._showTl.play();
	}

	hide() {
		this._showTl.kill();
		this._hideTl.play();
	}

	_update(delta, time) {
		// if (this.webGLCanvas) {
		//     this.webGLCanvas.setUniform('uTime', time);
		//     this.webGLCanvas.render();
		// }
	}

	_scrollHandler(currentScroll) {
	}

	resize(width = States.width, height = States.height) {
		// if (this.scroll)
		//     this.scroll.resize(width, height);

		// if (this.webGLCanvas)
		//     this.webGLCanvas.resize(width, height);
	}

	_next() {
		this.emit(PageEvent.NEXT);
	}

	_destroy() {
		// if (this.scroll)
		//     this.scroll.destroy();

		// if (this.webGLCanvas)
		//     this.webGLCanvas.destroy();

		this._next();
		this.emit(PageEvent.PAGE_DESTROYED);
	}

	_getPersitance() {
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/js/pages/page.js